import React from 'react';
import { Table } from 'semantic-ui-react';

const ListRow = () => allFiles => {
  const {
    id, status, inputFileName,
  } = allFiles;

  return (
    <Table.Row key={id}>
      <Table.Cell className='table-field'>
        <p>
          {inputFileName}
        </p>{' '}
      </Table.Cell>
      <Table.Cell className='table-field'>{status}</Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
